import React from "react";
import { Card, Image } from "react-bootstrap";

const AdminRecord = (props) => {
  return (
    <div className="container mt-2">
      <Card>
        <Card.Body>
          <div className="row">
            <Image thumbnail src={props.admin.image}></Image>
            <h4>{props.admin.name}</h4>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AdminRecord;
